import React, { useEffect, useState } from 'react';

import { MiniChatterton, Chatterton } from './Chatterton';
import { MiniSpeak2Me, Speak2Me } from './Speak2me';
import { MiniAdvise2Me, Advise2Me } from './Advise2me';
import { MiniLead2Me, Lead2Me } from './Lead2me';

import { MiniWebAnalytics, WebAnalytics } from './WebAnalytics';
import { Typography, useMediaQuery } from '@mui/material';
import { Analytics, BubbleChart, Recommend } from '@mui/icons-material';
import { Greensights, MiniGreensights } from './Greensights';
import { MiniRecommendations, Recommendations } from './Recommendations';
import { ControlledTabulate, TabItem } from 'app/components/tabulation';
import { Translate } from 'react-jhipster';
import { Box } from '@mui/system';
import { Theme } from '@mui/material/styles';

export const ProductSlider = () => {
  const [selectedTab, setSelectedTab] = useState('0');
  const [hover, setHover] = useState(null);
  // const theme = useTheme();
  const matches = useMediaQuery((theme: Theme) => theme.breakpoints.up('sm'));
  const mobileVersion = useMediaQuery((theme: Theme) => theme.breakpoints.up('md'));

  const swipeTab = () => {
    if (!hover) {
      if (selectedTab === '3') setSelectedTab('0');
      else setSelectedTab(String(Number(selectedTab) + 1));
    }
  };

  useEffect(() => {
    const interval = setInterval(() => swipeTab(), mobileVersion ? 4000 : 6000);

    return () => clearInterval(interval);
  }, [selectedTab, hover]);

  return (
    <Box
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      sx={{ height: mobileVersion ? '40vh' : '80vh' }}
    >
      <ControlledTabulate tabValue={selectedTab} setTabValue={value => setSelectedTab(value)} variant="fullWidth">
        <TabItem
          tab={{
            label: (
              <Typography fontSize={{ xs: '1rem', md: '1.5rem' }}>
                <Translate contentKey="module-factory.chat2me">Chat2Me</Translate>
              </Typography>
            ),
            ...(matches && {
              icon: <Analytics />,
              iconPosition: 'start',
            }),
            sx: {
              borderBottom: theme => `${theme.palette.divider} solid 1px`,
            },
          }}
        >
          {mobileVersion ? <Chatterton /> : <MiniChatterton />}
        </TabItem>
        <TabItem
          tab={{
            label: (
              <Typography fontSize={{ xs: '1rem', md: '1.5rem' }}>
                <Translate contentKey="module-factory.speak2me">Speak2Me</Translate>
              </Typography>
            ),
            ...(matches && {
              icon: <Recommend />,
              iconPosition: 'start',
            }),
            sx: {
              borderBottom: theme => `${theme.palette.divider} solid 1px`,
            },
          }}
        >
          {mobileVersion ? <Speak2Me /> : <MiniSpeak2Me />}
        </TabItem>
        <TabItem
          tab={{
            label: (
              <Typography fontSize={{ xs: '1rem', md: '1.5rem' }}>
                <Translate contentKey="module-factory.advise2me">Advise2Me</Translate>
              </Typography>
            ),
            ...(matches && {
              icon: <BubbleChart />,
              iconPosition: 'start',
            }),
            sx: {
              borderBottom: theme => `${theme.palette.divider} solid 1px`,
            },
          }}
        >
          {mobileVersion ? <Advise2Me /> : <MiniAdvise2Me />}
        </TabItem>
        <TabItem
          tab={{
            label: (
              <Typography fontSize={{ xs: '1rem', md: '1.5rem' }}>
                <Translate contentKey="module-factory.lead2me">Lead2Me</Translate>
              </Typography>
            ),
            ...(matches && {
              icon: <BubbleChart />,
              iconPosition: 'start',
            }),
            sx: {
              borderBottom: theme => `${theme.palette.divider} solid 1px`,
            },
          }}
        >
          {mobileVersion ? <Lead2Me /> : <MiniLead2Me />}
        </TabItem>
      </ControlledTabulate>
    </Box>
  );
};
